import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { WalletProvider } from "@/wallet/WalletContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Tokenomics from "@/pages/Tokenomics";
import NftGallery from "@/pages/NftGallery";
import NftDetail from "@/pages/NftDetail";
import Mint from "@/pages/Mint";
import MyNfts from "@/pages/MyNfts";
import Ecosystem from "@/pages/Ecosystem";
import Roadmap from "@/pages/Roadmap";
import Whitepaper from "@/pages/Whitepaper";
import Transparency from "@/pages/Transparency";
import Faq from "@/pages/Faq";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <LanguageProvider>
      <WalletProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/tokenomics" element={<Tokenomics />} />
              <Route path="/nfts" element={<NftGallery />} />
              <Route path="/nfts/:slug" element={<NftDetail />} />
              <Route path="/mint" element={<Mint />} />
              <Route path="/my-nfts" element={<MyNfts />} />
              <Route path="/ecosystem" element={<Ecosystem />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/whitepaper" element={<Whitepaper />} />
              <Route path="/transparency" element={<Transparency />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/terms" element={<Legal doc="terms" />} />
              <Route path="/privacy" element={<Legal doc="privacy" />} />
              <Route path="/risks" element={<Legal doc="risks" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </WalletProvider>
    </LanguageProvider>
  );
}

export default App;
